(function($) {
	'use strict';

	$.widget('msv.ripplefx', {

		options: {
			duration: .75
		},

		_create: function() {
			var self = this;


			var button = self.element;
			var rippleElement = '<svg class="ripple-obj"><use height="100" width="100" xlink:href="#ripply-scott" class="js-ripple"></use></svg>';
			button.append(rippleElement);

			this.options.ripple = self.element.find('.js-ripple');


			button.click(function(event) {
				self._rippleAnimation(event, self.options.duration);
			});

		},

		_rippleAnimation: function(event, timing) {
			// console.log(event)
			var tl = new TimelineMax();
			var x = event.offsetX,
				y = event.offsetY,
				w = event.target.offsetWidth,
				h = event.target.offsetHeight,
				offsetX = Math.abs((w / 2) - x),
				offsetY = Math.abs((h / 2) - y),
				deltaX = (w / 2) + offsetX,
				deltaY = (h / 2) + offsetY,
				scale_ratio = Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));

			tl.fromTo(this.options.ripple, timing, {
				x: x,
				y: y,
				transformOrigin: '50% 50%',
				scale: 0,
				opacity: 1,
				ease: Linear.easeIn
			}, {
				scale: scale_ratio,
				opacity: 0
			});
			// console.log(this.options.ripple)

			return tl;
		}



	});

})(jQuery);